import { Box, FormControl, FormErrorMessage, Radio, RadioGroup, Spinner, Stack, Text } from '@chakra-ui/react'
import type { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos/Travel'
import { SelectionType } from 'brokertslib/src/enums'
import { Controller, useFormContext } from 'BrokerTsLib/src/rhf'

import { FormLabel } from '../../components/FormLabel'
import { RadioStack } from '../../components/RadioStack'
import { useSelections } from '../../hooks'


export const TripType = ({ isContracted }: { isContracted: boolean }) => {
  const { control, formState: { errors } } = useFormContext<InsuranceParamsTravelDto>()

  const { data: dataReason, isLoading: isLoadingReason, isFetching: isFetchingReason } = useSelections(SelectionType.TravelReason)

  return (
    <FormControl isInvalid={!!errors.travel?.reason} isRequired>
      <Stack direction={'row'}>
        <FormLabel
          tooltip={
            <Box>
              <strong>POBYTOVÁ CESTA</strong>
              <Text>Cesta, kterou pojištěný uskutečňuje za účelem odpočinkové a rekreační turistiky, studijní pobyt a stáž, pobyty au pair, brigády studentů.</Text><br />
              <strong>POZNÁVACÍ CESTA</strong>
              <Text>Cesta, kterou pojištěný uskutečňuje za účelem odpočinkové, rekreační turistiky nebo rekreačních sportů.</Text><br />
              <strong>PRACOVNÍ CESTA</strong>
              <Text>Cesta, kterou pojištěný uskutečňuje za účelem plnění pracovních úkolů nebo v přímé souvislosti s plněním těchto pracovních úkolů zaměstnance vyslaného zaměstnavatelem, fyzické osoby nebo podnikatele (např. administrativní činnosti).</Text><br />
              <strong>PRACOVNÍ CESTA (manuální)</strong>
              <Text>Cesta, kterou pojištěný uskutečňuje za účelem plnění pracovních úkolů nebo v přímé souvislosti s plněním těchto pracovních úkolů zaměstnance vyslaného zaměstnavatelem, fyzické osoby nebo podnikatele (např. zednické práce).</Text>
            </Box>
          }>
          Důvod cesty
        </FormLabel>
        {(isFetchingReason || isLoadingReason) && <Spinner />}
      </Stack>
      <Controller
        name="travel.reason"
        control={control}
        render={({ field: { onChange, value } }) => (
          <RadioGroup onChange={e => onChange(parseInt(e))} value={value?.toString() ?? ''} isDisabled={isContracted}>
            <RadioStack variant="stackedTile">
              {dataReason?.map((item) => (
                <Radio value={item.id.toString()} key={item.id}>
                  {item.description}
                </Radio>
              ))}
            </RadioStack>
          </RadioGroup>
        )}
      />
      {errors.travel?.reason && <FormErrorMessage>{errors.travel.reason.message}</FormErrorMessage>}
    </FormControl>
  )
}
